import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../promo';
import { siteType } from '../../constants/configMap';
export function appendPromoVisit(promoName) {
    var data = {
        siteType: siteType,
        promoName: promoName
    };
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_APPEND_PROMO_VISIT
            },
            _a[CALL_API] = {
                endpoint: "/api/promo",
                method: 'PUT',
                types: [
                    ActionTypes.SUCCESS_FETCH_APPEND_PROMO_VISIT,
                    ActionTypes.FAILURE_FETCH_APPEND_PROMO_VISIT
                ],
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/promo.js